var saveTimers = {};
var DEFAULT_LOCKED = ["actions", "row", "product"];
var DEFAULT_ANCHOR = "product";

function isLocked(header, locked) {
  return !!(header && locked.indexOf(header.value) !== -1);
}

function normalizeOrder(headers, options) {
  if (!Array.isArray(headers) || !headers.length) return headers;
  var locked = (options && options.locked) || DEFAULT_LOCKED;
  var anchor = (options && options.anchor) || DEFAULT_ANCHOR;

  var lockedHeaders = [];
  var pinnedHeaders = [];
  var restHeaders = [];

  headers.forEach(function (header) {
    if (!header) return;
    if (isLocked(header, locked)) {
      lockedHeaders.push(header);
      return;
    }
    if (header.pinned) {
      pinnedHeaders.push(header);
      return;
    }
    restHeaders.push(header);
  });

  lockedHeaders.sort(function (a, b) {
    return (a.originalIndex || 0) - (b.originalIndex || 0);
  });
  pinnedHeaders.sort(function (a, b) {
    return (a.pinOrder || 0) - (b.pinOrder || 0);
  });
  restHeaders.sort(function (a, b) {
    return (a.originalIndex || 0) - (b.originalIndex || 0);
  });

  var anchorIndex = lockedHeaders.findIndex(function (header) {
    return header.value === anchor;
  });
  if (anchorIndex > -1 && anchorIndex !== lockedHeaders.length - 1) {
    var anchorHeader = lockedHeaders.splice(anchorIndex, 1)[0];
    lockedHeaders.push(anchorHeader);
  }

  var next = lockedHeaders.concat(pinnedHeaders, restHeaders);
  headers.splice.apply(headers, [0, headers.length].concat(next));
  return headers;
}

function getPersistKey(binding) {
  var value = binding && binding.value;
  if (!value || Array.isArray(value)) return null;
  return value.persistKey || value.settingsKey || null;
}

function getVueContext(vnode) {
  return vnode && vnode.context ? vnode.context : null;
}

function parseSavedValue(raw) {
  if (!raw) return null;
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : parsed && parsed.columns;
    } catch (e) {
      return null;
    }
  }
  if (typeof raw === "object") {
    if (Array.isArray(raw.columns)) return raw.columns;
  }
  return null;
}

export function serializeColumnSettings(headers) {
  if (!Array.isArray(headers)) return [];
  return headers.map(function (header, index) {
    return {
      value: header.value,
      width: header.width != null ? Number(header.width) : null,
      pinned: !!header.pinned,
      pinOrder: header.pinOrder != null ? Number(header.pinOrder) : null,
      originalIndex:
        header.originalIndex != null ? Number(header.originalIndex) : index,
    };
  });
}

export function applyColumnSettings(headers, snapshot, options) {
  if (!Array.isArray(headers) || !headers.length) return headers;
  if (!Array.isArray(snapshot) || !snapshot.length) return headers;

  var map = {};
  snapshot.forEach(function (item, index) {
    if (!item || item.value == null) return;
    map[item.value] = {
      width: item.width,
      pinned: !!item.pinned,
      pinOrder: item.pinOrder != null ? item.pinOrder : null,
      originalIndex: item.originalIndex != null ? item.originalIndex : index,
      order: index,
    };
  });

  headers.forEach(function (header, index) {
    if (!header) return;
    var saved = map[header.value];
    if (!saved) {
      if (header.originalIndex == null) header.originalIndex = index;
      return;
    }
    if (saved.width != null && !isNaN(saved.width)) {
      header.width = saved.width;
    }
    header.pinned = !!saved.pinned;
    header.pinOrder = saved.pinned ? saved.pinOrder : null;
    header.originalIndex = saved.originalIndex;
  });

  headers.sort(function (a, b) {
    var aSaved = map[a.value];
    var bSaved = map[b.value];
    var aOrder = aSaved ? aSaved.order : 9999;
    var bOrder = bSaved ? bSaved.order : 9999;
    return aOrder - bOrder;
  });

  normalizeOrder(headers, options || {});
  return headers;
}

export function loadColumnSettings(vm, key) {
  if (!vm || !vm.$axios || !vm.$endpoint || !key) {
    return Promise.resolve(null);
  }
  return vm.$axios
    .get(vm.$endpoint + "panel-ui", {
      params: { key: key },
    })
    .then(function (res) {
      var data = (res && res.data && (res.data.data || res.data)) || {};
      return parseSavedValue(data.value);
    })
    .catch(function () {
      return null;
    });
}

export function saveColumnSettings(vm, key, headers) {
  if (!vm || !vm.$axios || !vm.$endpoint || !key || !Array.isArray(headers)) {
    return Promise.resolve();
  }
  var payload = {
    key: key,
    value: JSON.stringify(serializeColumnSettings(headers)),
  };
  return vm.$axios.post(vm.$endpoint + "panel-ui", payload).catch(function () {
    // ignore persist errors to avoid breaking UI interactions
  });
}

export function scheduleSaveColumnSettings(vm, key, headers, delay) {
  if (!vm || !key || !Array.isArray(headers)) return;
  var wait = delay != null ? delay : 400;
  if (saveTimers[key]) {
    clearTimeout(saveTimers[key]);
  }
  saveTimers[key] = setTimeout(function () {
    saveColumnSettings(vm, key, headers);
    saveTimers[key] = null;
  }, wait);
}

export function persistFromDirective(vnode, binding, headers) {
  var key = getPersistKey(binding);
  var vm = getVueContext(vnode);
  if (!key || !vm || !Array.isArray(headers)) return;
  scheduleSaveColumnSettings(vm, key, headers);
}

export default {
  serializeColumnSettings: serializeColumnSettings,
  applyColumnSettings: applyColumnSettings,
  loadColumnSettings: loadColumnSettings,
  saveColumnSettings: saveColumnSettings,
  scheduleSaveColumnSettings: scheduleSaveColumnSettings,
  persistFromDirective: persistFromDirective,
};
